import { useCallback, useEffect, useRef } from "react";
import classnames from "classnames";
import Image from "next/image";

import { useApp } from "@context/AppProvider";
import { useCart } from "@context/CartProvider";
import SeoMeta from "@components/common/seo";
import styles from "@styles/checkout.module.scss";
import CheckOutEmpty from "@components/checkout/CheckOutEmpty";
import Checkout from "@components/checkout";
import Loading from "@components/Loading";

function CheckoutPage() {
  const {
    idb: { user, session },
  } = useApp();
  const { state, dispatch, loadCart } = useCart();

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  const cartCount = state.items
    ? state.items.map((item) => item.quantity || 0).reduce((a, b) => a + b, 0)
    : 0;
  //----Scroll-------
  const scollToRef = useRef({});
  const executeScroll = (char) => {
    window.scroll({
      top: scollToRef.current[char]?.offsetTop - 50,
      left: 0,
      behavior: "smooth",
    });
  };

  const setActiveTab = (char) => {
    let classList = scollToRef.current[`${char}Tab`].classList[0];
    if (!classList || (classList && !classList.includes("active"))) {
      scollToRef.current[`bagTab`].classList.remove(styles.active);
      scollToRef.current[`shippingTab`].classList.remove(styles.active);
      scollToRef.current[`paymentTab`].classList.remove(styles.active);
      scollToRef.current[`${char}Tab`].classList.add(styles.active);
    }
  };

  const handleScroll = useCallback(() => {
    if (
      scollToRef.current?.bag?.offsetTop - 70 < window?.scrollY &&
      scollToRef.current?.shipping?.offsetTop - 70 > window?.scrollY
    )
      setActiveTab("bag");
    else if (
      scollToRef.current?.shipping?.offsetTop - 70 < window?.scrollY &&
      scollToRef.current?.payment?.offsetTop - 70 > window?.scrollY
    )
      setActiveTab("shipping");
    else if (scollToRef.current?.payment?.offsetTop - 70 < window?.scrollY)
      setActiveTab("payment");
  }, []);

  const scrollListner = useCallback(() => {
    document.addEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const removeListner = useCallback(() => {
    document.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);
  useEffect(() => {
    scrollListner();

    return () => {
      dispatch({
        type: "INIT_CART",
        data: {
          loading: true,
          is18Plus: false,
          isVerified18Plus: false,
          currentDate: "",
        },
      });
      removeListner();
    };
  }, [scrollListner, removeListner, dispatch]);

  return state.loading ? (
    <Loading />
  ) : (
    <>
      <SeoMeta />
      <div className={styles.checkoutBlock}>
        <div className={styles.bagAddList}>
          <ul
            className={classnames("container d-flex", styles.alignItemsCenter)}
          >
            <li
              onClick={() => executeScroll("bag")}
              ref={(ref) => (scollToRef.current["bagTab"] = ref)}
              className={styles.active}
            >
              <i>
                <Image
                  src="/assets/images/bag.png"
                  alt="cart-icon"
                  width={24}
                  height={24}
                />
              </i>{" "}
              <span>
                {cartCount > 0
                  ? `Bag (${cartCount} ${cartCount > 1 ? "items" : "item"})`
                  : "Bag"}
              </span>
            </li>
            <li
              onClick={() => executeScroll("shipping")}
              ref={(ref) => (scollToRef.current["shippingTab"] = ref)}
            >
              <i>
                <Image
                  src="/assets/images/car-icon.svg"
                  alt="car-icon"
                  width={24}
                  height={24}
                />
              </i>{" "}
              <span>Delivery</span>
            </li>
            <li
              onClick={() => executeScroll("payment")}
              ref={(ref) => (scollToRef.current["paymentTab"] = ref)}
            >
              <i>
                <Image
                  src="/assets/images/credit-icon.svg"
                  alt="credit-icon"
                  width={24}
                  height={24}
                />
              </i>{" "}
              <span>Payment</span>
            </li>
          </ul>
        </div>
        {cartCount > 0 ? (
          <Checkout
            styles={styles}
            state={state}
            session={session}
            user={user}
            dispatch={dispatch}
            scollToRef={scollToRef}
          />
        ) : (
          <CheckOutEmpty styles={styles} />
        )}
      </div>
    </>
  );
}

CheckoutPage.Layout = true;
CheckoutPage.HideMenu = true;
CheckoutPage.HideFooter = true;
CheckoutPage.HideGoodCause = true;

export default CheckoutPage;
